import { Badge, type BadgeProps } from '@/ui';

type Tone = 'plan' | 'role' | 'attention';

type Props = Omit<BadgeProps, 'colorScheme'> & {
  /**
   * `plan` — pink plan tint ("Current plan", "Active", "Recommended").
   * `role` — dark solid pill (a role, e.g. "Owner").
   * `attention` — red tint for a plan state the owner needs to act on
   * ("Payment failed", "Expired"). Deliberately not used for "Ending", which is
   * a choice they already made rather than a problem.
   */
  tone?: Tone;
};

const TONES: Record<Tone, { bg: string; color: string }> = {
  plan: { bg: 'brand.40', color: 'brand.500' },
  role: { bg: 'gray.900', color: 'white' },
  attention: { bg: 'destructive.50', color: 'destructive.500' },
};

// The pill beside a plan name or member row. Mirrors the sidebar's
// AccountListItem badge so the two rails match.
export const PlanBadge = ({ tone = 'plan', ...props }: Props) => (
  <Badge
    borderRadius="ah-pill"
    flexShrink={0}
    fontSize="ah-status"
    fontWeight="semibold"
    px="2.5"
    py="0.5"
    textTransform="none"
    {...TONES[tone]}
    {...props}
  />
);
